import Siema from 'siema';

const membershipData = {
	'venues': [
		{ range: '<1000', Pathfinder: { cost: 3000, seats: 15, officeHours: 0 }, Progressor: { cost: 3000, seats: 10, officeHours: 1 }, Pacesetter: { cost: 3000, seats: 5, officeHours: 2 } },
		{ range: '1001-2500', Pathfinder: { cost: 3300, seats: 25, officeHours: 0 }, Progressor: { cost: 3300, seats: 15, officeHours: 1 }, Pacesetter: { cost: 3300, seats: 10, officeHours: 2 } },
		{ range: '2501-7500', Pathfinder: { cost: 3850, seats: 30, officeHours: 0 }, Progressor: { cost: 3850, seats: 20, officeHours: 1 }, Pacesetter: { cost: 3850, seats: 15, officeHours: 2 } },
		{ range: '7501-15000', Pathfinder: { cost: 5300, seats: 35, officeHours: 0 }, Progressor: { cost: 5300, seats: 25, officeHours: 1 }, Pacesetter: { cost: 5300, seats: 20, officeHours: 2 } },
		{ range: '15001-20000', Pathfinder: { cost: 6360, seats: 40, officeHours: 0 }, Progressor: { cost: 6360, seats: 30, officeHours: 1 }, Pacesetter: { cost: 6360, seats: 25, officeHours: 2 } },
		{ range: '20001-30000 cap', Pathfinder: { cost: 7950, seats: 55, officeHours: 0 }, Progressor: { cost: 7950, seats: 35, officeHours: 2 }, Pacesetter: { cost: 7950, seats: 30, officeHours: 3 } },
	],
	'inHouseAndBrand': [
		{ range: '4-10', Pathfinder: { cost: 3000, seats: 15, officeHours: 0 }, Progressor: { cost: 3000, seats: 10, officeHours: 1 }, Pacesetter: { cost: 3000, seats: 5, officeHours: 2 } },
		{ range: '11-40', Pathfinder: { cost: 3300, seats: 25, officeHours: 0 }, Progressor: { cost: 3300, seats: 15, officeHours: 1 }, Pacesetter: { cost: 3300, seats: 10, officeHours: 2 } },
		{ range: '41-80', Pathfinder: { cost: 3850, seats: 30, officeHours: 0 }, Progressor: { cost: 3850, seats: 20, officeHours: 1 }, Pacesetter: { cost: 3850, seats: 15, officeHours: 2 } },
		{ range: '81-150', Pathfinder: { cost: 5300, seats: 35, officeHours: 0 }, Progressor: { cost: 5300, seats: 25, officeHours: 1 }, Pacesetter: { cost: 5300, seats: 20, officeHours: 2 } },
		{ range: '150-225', Pathfinder: { cost: 6360, seats: 40, officeHours: 0 }, Progressor: { cost: 6360, seats: 30, officeHours: 1 }, Pacesetter: { cost: 6360, seats: 25, officeHours: 2 } },
		{ range: '226-350', Pathfinder: { cost: 7155, seats: 45, officeHours: 0 }, Progressor: { cost: 7155, seats: 35, officeHours: 1 }, Pacesetter: { cost: 7155, seats: 30, officeHours: 2 } },
		{ range: '351-500', Pathfinder: { cost: 7685, seats: 50, officeHours: 0 }, Progressor: { cost: 7685, seats: 40, officeHours: 2 }, Pacesetter: { cost: 7685, seats: 35, officeHours: 3 } },
		{ range: '501-750 cap', Pathfinder: { cost: 7950, seats: 55, officeHours: 0 }, Progressor: { cost: 7950, seats: 45, officeHours: 2 }, Pacesetter: { cost: 7950, seats: 40, officeHours: 3 } },
	],
	'agenciesAndSuppliers': [
		{ range: '4-10', Pathfinder: { cost: 3000, seats: 15, officeHours: 0 }, Progressor: { cost: 3000, seats: 10, officeHours: 1 }, Pacesetter: { cost: 3000, seats: 5, officeHours: 2 } },
		{ range: '11-40', Pathfinder: { cost: 3300, seats: 25, officeHours: 0 }, Progressor: { cost: 3300, seats: 15, officeHours: 1 }, Pacesetter: { cost: 3300, seats: 10, officeHours: 2 } },
		{ range: '41-80', Pathfinder: { cost: 3850, seats: 30, officeHours: 0 }, Progressor: { cost: 3850, seats: 20, officeHours: 1 }, Pacesetter: { cost: 3850, seats: 15, officeHours: 2 } },
		{ range: '81-150', Pathfinder: { cost: 5300, seats: 35, officeHours: 0 }, Progressor: { cost: 5300, seats: 25, officeHours: 1 }, Pacesetter: { cost: 5300, seats: 20, officeHours: 2 } },
		{ range: '150-225', Pathfinder: { cost: 6360, seats: 40, officeHours: 0 }, Progressor: { cost: 6360, seats: 30, officeHours: 1 }, Pacesetter: { cost: 6360, seats: 25, officeHours: 2 } },
		{ range: '226-350', Pathfinder: { cost: 7155, seats: 45, officeHours: 0 }, Progressor: { cost: 7155, seats: 35, officeHours: 1 }, Pacesetter: { cost: 7155, seats: 30, officeHours: 2 } },
		{ range: '351-500', Pathfinder: { cost: 7685, seats: 50, officeHours: 0 }, Progressor: { cost: 7685, seats: 40, officeHours: 2 }, Pacesetter: { cost: 7685, seats: 35, officeHours: 3 } },
		{ range: '501-750 cap', Pathfinder: { cost: 7950, seats: 55, officeHours: 0 }, Progressor: { cost: 7950, seats: 45, officeHours: 2 }, Pacesetter: { cost: 7950, seats: 40, officeHours: 3 } },
	],
	'professionalMembership': [
		{ range: '1-3', Individual: { cost: 550, seats: 2, officeHours: 0 }},
	],
};

const descriptions = {
	Pathfinder: {
		part1: 'Perfect for businesses taking their first steps in sustainability, the Pathfinder membership provides essential education and support. <br />' +
			'<br />' +
			'Members can access training, workshops, sustainability resources and toolkits, a structured progression review, and a webinar series for ongoing learning. It also includes entry to events, and action groups, plus a TRACE license for one event carbon footprint measurement.',
		part2: 'The cost of membership is determined by the type and size of your organisation, venue or team. Don\'t worry - the stage of your organisation\'s sustainability journey doesn’t affect the pricing. We’re here to support you, no matter where you are on your journey.',
	},
	Progressor: {
		part1: 'Designed for businesses ready to advance their sustainability efforts, the Progressor membership offers tailored support, including training, workshops, and one-on-one expert-led sessions. Members benefit from the webinar series, TRACE license for one event, and access to member events, action groups, steering groups, and more.',
		part2: 'The cost of membership is determined by the type and size of your organisation, venue or team. Don\'t worry - the stage of your organisation\'s sustainability journey doesn’t affect the pricing. We’re here to support you, no matter where you are on your journey.',
	},
	Pacesetter: {
		part1: 'For businesses driving innovation in sustainability, the Pacesetter Membership provides exclusive access to leadership opportunities and high-level industry collaboration. It includes training, one-on-one expert sessions, workshops, and access to partner programmes. Members can also take advantage of events, action and steering groups and are eligible for advisory board applications, ensuring they stay at the forefront of industry transformation.',
		part2: 'The cost of membership is determined by the type and size of your organisation, venue or team. Don\'t worry - the stage of your organisation\'s sustainability journey doesn’t affect the pricing. We’re here to support you, no matter where you are on your journey.',
	},
	Individual: {
		part1: 'Designed for individual event professionals, this membership equips you with the knowledge and network needed to deliver sustainable events. It includes access to training, resources & toolkits, webinar series, events, and participation in action groups.',
		part2: '',
	},
};

export default {
	init() {
		// JavaScript to be fired on all pages
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired

        if (document.querySelector('.whats-included-slider')) {
            const whatsIncludedSlider = new Siema({
                selector: '.whats-included-slider',
                draggable: false,
                loop: true,
            });

            document.querySelector('#nextItem').addEventListener('click', (e) => {
                e.preventDefault();
                whatsIncludedSlider.next();
            })
            document.querySelector('#previousItem').addEventListener('click', (e) => {
                e.preventDefault();
                whatsIncludedSlider.prev();
            })
        }

        if (window.location.href.search('#wow-modal-id') > 0) {
            const anchor = window.location.href.substring(window.location.href.search('#wow-modal-id'));

            setTimeout(() => {
                document.querySelector(`.links a[href='${anchor}']`).click();
            }, 500);

        }

		$('#organisationType').on('change', function () {
			console.log('change', $(this).val());
			const sizeOfVenue = $('#sizeOfVenue');
			const organisationSize = $('#organisationSize');
			const teamSize = $('#teamSize');
			const organisationProgress = $('#organisationProgress');
			const progressResult = $('#progressResult');

			const sizeOfVenueParent = sizeOfVenue.parents('.dropdown-box');
			const organisationSizeParent = organisationSize.parents('.dropdown-box');
			const teamSizeParent = teamSize.parents('.dropdown-box');
			const organisationProgressParent = organisationProgress.parents('.dropdown-box');

			sizeOfVenue.val('');
			organisationSize.val('');
			teamSize.val('');
			organisationProgress.val('');

			sizeOfVenueParent.addClass('hidden');
			organisationSizeParent.addClass('hidden');
			teamSizeParent.addClass('hidden');
			organisationProgressParent.addClass('hidden');
			progressResult.addClass('hidden');

			if ($(this).val() === 'Venue') {
				console.log(sizeOfVenueParent);
				sizeOfVenueParent.removeClass('hidden');
			} else if ($(this).val() === 'In-house' || $(this).val() === 'Brand/Corporate') {
				teamSizeParent.removeClass('hidden');
			} else {
				organisationSizeParent.removeClass('hidden');
			}

			$('[name="membership_calculator_organisation_type"]').val($(this).val());
		});

		$('#sizeOfVenue,#organisationSize,#teamSize').on('change', function () {
			const organisationProgress = $('#organisationProgress');
			const organisationProgressParent = organisationProgress.parents('.dropdown-box');
			const progressResult = $('#progressResult');

			organisationProgress.val('');
			organisationProgressParent.addClass('hidden');
			progressResult.addClass('hidden');

			if ($(this).val() !== '') {
				organisationProgressParent.removeClass('hidden');
				$('[name="membership_calculator_size"]').val($(this).val());
			}
		});

		$('#organisationProgress').on('change', function () {
			const progressResult = $('#progressResult');
			progressResult.addClass('hidden');

			if ($(this).val() !== '') {
				progressResult.removeClass('hidden');
				$('[name="membership_calculator_package"]').val($(this).val());
			}
		});

		function determineCategory(organisationSize, organisationType) {
			if (organisationSize === '1-3') return 'professionalMembership';
			if (organisationType === 'Venue') return 'venues';
			if (organisationType === 'In-house and brand') return 'inHouseAndBrand';
			return 'agenciesAndSuppliers';
		}

		function matchData(size, dataset) {
			return dataset.find(row => {
				return row.range === size;
			});
		}

		function calculateMembership() {
			const organisationType = document.querySelector('#organisationType').value; // e.g., 'Venues'
			let organisationProgress = document.querySelector('#organisationProgress').value; // 'Pathfinder', etc.
			const numericValue =
				document.querySelector('#sizeOfVenue').value ||
				document.querySelector('#organisationSize').value ||
				document.querySelector('#teamSize').value;

			const category = determineCategory(numericValue, organisationType);
			const dataset = membershipData[category];

			organisationProgress = category === 'professionalMembership' ? 'Individual' : organisationProgress;
			console.log(numericValue, dataset);
			const matchedRow = matchData(numericValue, dataset);

			if (!matchedRow) {
				document.querySelector('#chosen-package').textContent = 'No matching data found.';
				return;
			}


			const result = category === 'professionalMembership' ? matchedRow['Individual'] : matchedRow[organisationProgress];

			if (!result) {
				document.querySelector('#chosen-package').textContent = 'Invalid selection.';
				return;
			}

			// Display results
			document.querySelector('#chosen-package').textContent = organisationProgress;
			document.querySelector('#package-description').innerHTML = descriptions[organisationProgress].part1;
			// document.querySelector('#package-seats').querySelector('.right').textContent = result.seats;
			// document.querySelector('#package-office-hours').querySelector('.right').textContent = result.officeHours;
			document.querySelector('#package-price').querySelector('.right').textContent = `£${result.cost.toFixed(2)}`;
			document.querySelector('#additional-information').textContent = descriptions[organisationProgress].part2;
		}

		document.querySelector('#organisationProgress').addEventListener('change', function (e) {
			e.preventDefault();
			calculateMembership();
		});
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/membership.js